require("!!/var/www/html/node_modules/script-loader/addScript.js")(require("!!/var/www/html/node_modules/raw-loader/index.js!/var/www/html/node_modules/match-media/matchMedia.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/match-media/matchMedia.js
// module id = 640
// module chunks = 1